<template>
    <div class="l-default">
        <y-rogue-wrapper
            name="header"
            type="ecommerce-shop"
            :site-logo="$settings('site_logos.header.link')"
            :site-title="$settings('site_title.site_title')"
            :menu="getMenu('main-$')"
            :login-text="$t('header.auth_button')"
            :login-link="{name:'auth-login'}"
            :cart-count="$store.getters['cart/wareCount']"
            :wallet-charge-button="walletChargeButton"
            :navigation="$config('dashboard.nav')"
            product-categories
            contact-info="fixed_tel"
            category-slug="products-category"
            category-route-name="products"
            @cartEvent="routeToCart"
        />

        <slot />

        <y-loading
            :active="$wait.is('loading-page')"
            height="100vh"
            size="50px"
        />

        <y-rogue-wrapper
            name="backToTop"
            type="simple"
            size="large"
            class="l-default__back-to-top"
        />

        <y-rogue-wrapper
            name="footer"
            type="ecommerce-shop"
            :site-logo="$settings('site_logos.footer.link')"
            :site-title="$settings('site_title.site_title')"
            :site-description="$settings('content.about')"
            :menu-title="$settings('content.footer_menu_title1')"
            :second-menu-title="$settings('content.footer_menu_title2')"
            :menu="getMenu('footer-$')"
            :second-menu="getMenu('service-$')"
            :contact-title="$t('footer.contact_title')"
            :socials-title="$t('footer.socials_title')"
            :socials-links="$settings('socials')"
            :copy-right-text="$settings('copy_right.copy_right')"
            :powered-by-text="$config('project.quarkino.fa')"
            :contact-details="$settings('contact_details')"
            :contact-details-text="$settings('content.footer_slogan')"
            :trust-seal="$settings('trusted.trusted')"
            color="white"
            background-color="body"
        />
    </div>
</template>

<script>
    export default {
        name: 'DefaultLayout',

        /**
         * @inheritDoc
         */
        data() {
            return {
                walletChargeButton: {
                    label: this.$t('dashboard.sidebar.charge_wallet'),
                    size : 'small',
                    icon : {
                        name  : 'plus',
                        prefix: 'fa',
                    },
                    link: {
                        name: 'dashboard-charge-wallet',
                    },
                },
            };
        },

        methods: {
            /**
             * Route to cart
             */
            routeToCart() {
                this.$router.push({ name: 'cart' }).catch((error) => {
                    this.handleError(error);
                });
            },
        },
    };
</script>
